import {resolveGoogExport} from 'dgetz/tsclj'

const allPolicyValueOptions = [100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000, 500000, 550000, 600000, 650000, 700000, 750000, 800000, 850000, 900000, 950000, 1000000, 1100000, 1200000, 1300000, 1400000, 1500000, 1600000, 1700000, 1800000, 1900000, 2000000, 2250000, 2500000, 2750000, 3000000, 3250000, 3500000, 3750000, 4000000, 4250000, 4500000, 4750000, 5000000, 5500000, 6000000, 6500000, 7000000, 7500000, 8000000]

const policyValues3MmAndUnder = allPolicyValueOptions.filter(n => (n <= 3000000))
const carrierProductToFaceAmountOptionsMap = {
  'allianz/a49': policyValues3MmAndUnder,
  'allianz/ny': allPolicyValueOptions,
  'fsl/original': allPolicyValueOptions,
  'ladder/treehouse': policyValues3MmAndUnder,
  'prosperity/s-usa': allPolicyValueOptions,
  'prosperity/imo': allPolicyValueOptions,
  'amica/original': allPolicyValueOptions,
}

function carrierProductToFaceAmountOptions(carrierProduct) {
  const result = carrierProductToFaceAmountOptionsMap[carrierProduct]
  if (!result) {
    throw new Error(`No matching carrier-product: ${carrierProduct}`)
  }
  return result
}

export function carrierProductToFaceAmountOptionsBigdec(carrierProduct) {
  const {BigNumber} = resolveGoogExport('ladder.closure')
  return carrierProductToFaceAmountOptions(carrierProduct).map(n => new BigNumber(n))
}
